import { render } from "./PostItem.vue?vue&type=template&id=571e43d0&scoped=true&ts=true"
import script from "./PostItem.vue?vue&type=script&lang=ts"
export * from "./PostItem.vue?vue&type=script&lang=ts"

import "./PostItem.vue?vue&type=style&index=0&id=571e43d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571e43d0"]])

export default __exports__